"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawString = exports.Hash = exports.Uint32Opt = exports.Uint8Opt = exports.ScriptId = void 0;
const base_1 = require("@ckb-lumos/base");
const codec_1 = require("@ckb-lumos/codec");
const helpers_1 = require("../helpers");
exports.ScriptId = codec_1.molecule.struct({
    codeHash: base_1.blockchain.Byte32,
    hashType: base_1.blockchain.HashType,
}, ['codeHash', 'hashType']);
exports.Uint8Opt = codec_1.molecule.option(codec_1.number.Uint8);
exports.Uint32Opt = codec_1.molecule.option(codec_1.number.Uint32LE);
exports.Hash = base_1.blockchain.Byte32;
/**
 * The codec for packing/unpacking UTF-8 raw strings.
 * Should be packed like so: String.pack('something')
 */
exports.RawString = codec_1.molecule.byteVecOf({
    pack: (packable) => (0, helpers_1.bytifyRawString)(packable),
    unpack: (unpackable) => (0, helpers_1.bufferToRawString)(unpackable),
});
//# sourceMappingURL=utils.js.map